import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import { groupOperationHoursInDays } from 'modules/queues/common/utils/appointmentFormUtils';
import { Button, Icon } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import OOHDay from './components/OOHDay';
import theme from './ModalOOHAppointment.scss';


const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  operationSlots: PropTypes.object.isRequired,
  serviceName: PropTypes.string,
};

const defaultProps = {
  serviceName: null,
};

const ModalOOHAppointment = ({ intl, onCancel, operationSlots, serviceName }) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div>
        <FormattedMessage id="Appointments.Create.ServiceOOH.Dialog.Title" defaultMessage="** Service out of hours" />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <Choose>
        <When condition={ !isEmpty(operationSlots) }>
          <div className={ theme.contentTitle }>
            <FormattedHTMLMessage
              id="Appointments.Create.ServiceOOH.Dialog.TextAboveTable"
              defaultMessage="** The { serviceName } service is currently closed. <br/> Please try again during operating hours:"
              values={{ serviceName }}
            />
          </div>
          <div className={ theme.daysList }>
            { Object.keys(operationSlots).map(day => (
              <OOHDay
                key={ day }
                day={ day }
                value={ operationSlots[day] }
              />),
            ) }
          </div>
        </When>
        <Otherwise>
          <div className={ theme.unavailable }>
            <FormattedHTMLMessage
              id="Appointments.Create.ServiceOOH.Dialog.NoOperatingHours"
              defaultMessage="** The Service has no operating hours available. Please try again later"
            />
          </div>
        </Otherwise>
      </Choose>
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-ooh-appointment"
        label={ intl.formatMessage({
          id: 'General.Close',
          defaultMessage: '** Close',
        }) }
        background="red"
        onClick={ onCancel }
        iconPositionLeft
        size="small"
      />
    </div>
  </div>
);

ModalOOHAppointment.propTypes = propTypes;
ModalOOHAppointment.defaultProps = defaultProps;

export default compose(
  injectIntl,
  withProps(({ bodyValues, intl }) => ({
    operationSlots: groupOperationHoursInDays(bodyValues.operationHours, intl),
    serviceName: bodyValues.serviceName,
  })),
  withEscHandler,
)(ModalOOHAppointment);
